(function () {
  var wrapper = document.getElementById('back-to-top-wrapper');
  var btn = document.getElementById('back-to-top-btn');

  if (!wrapper || !btn) {
    console.warn('[back-to-top] Elements not found in DOM.');
    return;
  }

  var SHOW_AFTER_PX = 1000;
  var isShown = false;

  // Never cache a single container — always re-check ALL possible
  // scroll sources fresh, and use whichever one is actually scrolled.
  function getScrollTop() {
    var candidates = [
      window.pageYOffset,
      document.documentElement.scrollTop,
      document.body.scrollTop,
      document.scrollingElement ? document.scrollingElement.scrollTop : 0
    ];

    var pageWrapper = document.querySelector('.page-wrapper');
    if (pageWrapper) candidates.push(pageWrapper.scrollTop);

    var mainEl = document.querySelector('main, #MainContent');
    if (mainEl) candidates.push(mainEl.scrollTop);

    return Math.max.apply(null, candidates.filter(function (v) {
      return typeof v === 'number' && !isNaN(v);
    }));
  }

  function updateVisibility() {
    var scrollTop = getScrollTop();
    var shouldShow = scrollTop > SHOW_AFTER_PX;
    if (shouldShow !== isShown) {
      isShown = shouldShow;
      wrapper.classList.toggle('show', isShown);
    }
  }

  // Listen broadly — capture phase catches scroll on any nested element too
  document.addEventListener('scroll', updateVisibility, { passive: true, capture: true });
  window.addEventListener('scroll', updateVisibility, { passive: true });
  window.addEventListener('resize', updateVisibility);

  // Safety-net polling — now safe because getScrollTop() re-checks everything
  // fresh each time instead of relying on a stale cached container.
  setInterval(updateVisibility, 300);

  updateVisibility();

  btn.addEventListener('click', function () {
    var targets = [
      window,
      document.documentElement,
      document.body,
      document.scrollingElement,
      document.querySelector('.page-wrapper'),
      document.querySelector('main, #MainContent')
    ].filter(Boolean);

    targets.forEach(function (t) {
      try {
        if (t.scrollTo) {
          t.scrollTo({ top: 0, behavior: 'smooth' });
        } else {
          t.scrollTop = 0;
        }
      } catch (e) {}
    });
  });

  console.log('[back-to-top] Script v6 initialized. Trigger:', SHOW_AFTER_PX, 'px. Width-independent scroll detection active.');
})();